import {api} from './api/setup';
import {isLogged, logout} from '@/api/user';
import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export class GlobalMixin extends Vue {

    apiUrl(url: string) {
        return api(url);
    }

    isLogged() {
        return isLogged()
    }

    logout() {
        return logout()
    }

}
